module.exports = __webpack_public_path__ + "img/title_zh.7a485493.png";